<template>
    <div id="left-bar-billing">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-euro-sign"/>
                {{ $t("LeftBarBilling.billing") }}
            </li>
            <li class="has_sub">
                <router-link to="/billing/dashboard" class="waves-effect" :class="{ active: this.$route.name === 'billing-dashboard' }">
                    <i class="fa fa-chart-line"/>
                    <span> {{ $t("LeftBarBilling.dashboard") }} </span>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/billing/carriers" class="waves-effect" :class="{ active: inCarrierPages }">
                    <i class="fa fa-truck"/>
                    <span> {{ $t("LeftBarBilling.carriers") }} </span>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/billing/countries" class="waves-effect" :class="{ active: this.$route.name === 'countries' }">
                    <i class="fas fa-globe"/>
                    <span> {{ $t("LeftBarBilling.countries") }} </span>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/billing/currencies" class="waves-effect" :class="{ active: this.$route.name === 'currencies' }">
                    <i class="fa fa-euro-sign"/>
                    <span> {{ $t("LeftBarBilling.currencies") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"/>
    </div>
</template>

<script>
export default {
    name: "LeftBarBilling",
    computed: {
        inCarrierPages() {
            return this.$route.name === "carriers" || this.$route.name === "carrier" ||
                this.$route.name === "carrier-destination" || this.$route.name === "carrier-area";
        },
    },
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-billing {
        .waves-effect {
            &.active {
                border-left-color: $billing-color;
                i {
                    color: $billing-color;
                }
            }
            .waves-ripple {
                background-color: rgba($billing-color, 0.45) !important;
            }
        }
    }
</style>